// extracted by mini-css-extract-plugin
export default {"form":"SearchTab_form__TIHMe","inputGroup":"SearchTab_inputGroup__uUIIv","icon":"SearchTab_icon__VGEzg","textbox":"SearchTab_textbox__+R4IH"};